import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import {
  formatRatingScore,
  getRatingBarColor,
} from '../../LessonRatingsCard.helpers';

import styles from './LessonRatingsRow.module.scss';

const LessonRatingsRow = ({
  title,
  averageRating,
  count,
  isModule = false,
  isLesson = false,
  isExpanded = false,
  onToggle,
}: {
  title: string;
  averageRating: number;
  count: number;
  isModule?: boolean;
  isLesson?: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
}) => {
  const hasRatings = count > 0;

  return (
    <div
      className={cn(styles.row, {
        [styles.rowModule]: isModule,
        [styles.rowLesson]: isLesson,
      })}
      onClick={isModule ? onToggle : undefined}
    >
      <div className={styles.titleCell}>
        {isModule && (
          <Icon
            className={cn(styles.chevron, {
              [styles.chevronExpanded]: isExpanded,
            })}
            name="chevronDown"
          />
        )}
        <Typography
          className={styles.title}
          variant="body3"
          weight={isModule ? 'medium' : undefined}
          mode="compact"
        >
          {title}
        </Typography>
      </div>

      <div className={styles.barCell}>
        <div className={styles.barTrack}>
          {hasRatings && (
            <div
              className={styles.barFill}
              style={{
                width: `${(averageRating / 5) * 100}%`,
                backgroundColor: getRatingBarColor(averageRating),
              }}
            />
          )}
        </div>
      </div>

      <Typography
        className={styles.avgCell}
        variant="body3"
        weight="medium"
        mode="compact"
      >
        {hasRatings ? formatRatingScore(averageRating) : '—'}
      </Typography>

      <Typography className={styles.countCell} variant="body3" mode="compact">
        {count}
      </Typography>
    </div>
  );
};

export default React.memo(LessonRatingsRow) as any;
